import React from "react";
import { createBrowserRouter } from "react-router-dom";
import KYCsteps from "../components/pages/KYCsteps";
import RequestOTP from "../components/pages/requestOTP";
import VerifyOTP from "../components/pages/verifyOTP";
import Error from "../components/shared/error/errorComponent";
import { ROUTES_VARIANT } from "constants/routesVariant";
import AppShell from "@shared/appShell";
import { KYCCompleted } from "components/pages/KYCsteps/ocrSteps/pages/KYCCompleted";

// Define the routes for the application
const ROUTES = createBrowserRouter([
  {
    path: "/",
    element: <AppShell />,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <RequestOTP />,
        errorElement: <Error />,
      },
      {
        path: `${ROUTES_VARIANT.PROCESS}`,
        element: <KYCsteps />,
        errorElement: <Error />,
      },
      {
        path: `${ROUTES_VARIANT.VERIFY_OTP}`,
        element: <VerifyOTP />,
        errorElement: <Error />,
      },
      {
        path: `${ROUTES_VARIANT.FINISH}`,
        element: <KYCCompleted />,
        errorElement: <Error />,
      },
    ],
  },
]);

export default ROUTES;
